export const en = {
  'nav.dashboard': 'Dashboard',
  'nav.fields': 'Fields',
  'nav.planning': 'Planning',
  'nav.calendar': 'Calendar',
  'nav.statistics': 'Statistics',

  'shell.farmOverview': 'Farm overview',
  'shell.goodMorning': 'Good morning',
  'shell.synced': 'Synced',
  'shell.syncError': 'Not synced',
  'shell.syncError.title': 'Synchronization unavailable',
  'shell.syncError.httpStatus': 'HTTP status',
  'shell.syncError.unreachable':
    'The server cannot be reached. Check that your dedicated server is running and reachable on the network.',
  'shell.syncError.auth':
    'The server refused the request. Your session may have expired – try reloading the page.',
  'shell.syncError.notFound':
    'The server responded, but the expected data was not found. The API may be misconfigured or outdated.',
  'shell.syncError.server':
    'The server responded with an internal error. It may still be starting up or overloaded – try again in a moment.',
  'shell.syncError.generic':
    'The server responded unexpectedly, so data could not be synchronized.',
  'shell.gameServer': 'Game server',
  'shell.connected': 'Connected',

  'dashboard.overview': 'Overview',
  'dashboard.title': 'Your farm at a glance',
  'dashboard.subtitle': 'Field status, upcoming work and server activity.',
  'dashboard.newPlanning': 'New field planning',

  'dashboard.farmStatus': 'Farm status',
  'dashboard.runningSmoothly': 'Everything is running smoothly.',
  'dashboard.serverUpToDate':
    'Your game server is connected and field information is up to date.',
  'dashboard.serverConnected': 'Server connected',
  'dashboard.lastSync': 'Last sync just now',

  'dashboard.fields': 'Fields',
  'dashboard.totalFields': 'Total fields',
  'dashboard.totalArea': 'Total area',
  'dashboard.managedFarmland': 'Managed farmland',
  'dashboard.openTasks': 'Open tasks',
  'dashboard.planningItems': 'Planning items',
  'dashboard.nextHarvest': 'Next harvest',

  'dashboard.currentFieldStatus': 'Current field status',
  'dashboard.viewAll': 'View all',
  'dashboard.loadingFields': 'Loading fields...',
  'dashboard.noFields': 'No fields yet',
  'dashboard.noFieldsHint': 'Add your first field to track its status here.',
  'dashboard.addField': 'Add field',

  'dashboard.nextUp': 'Next up',
  'dashboard.plannedWork': 'Planned work',

  'dashboard.liveSync': 'Live Sync',
  'dashboard.dedicatedServerConnected': 'Dedicated server connected',

  'gameState.day': 'Day',
  'gameState.clock': '',

  'gameState.month.january': 'January',
  'gameState.month.february': 'February',
  'gameState.month.march': 'March',
  'gameState.month.april': 'April',
  'gameState.month.may': 'May',
  'gameState.month.june': 'June',
  'gameState.month.july': 'July',
  'gameState.month.august': 'August',
  'gameState.month.september': 'September',
  'gameState.month.october': 'October',
  'gameState.month.november': 'November',
  'gameState.month.december': 'December',
  'gameState.month.unknown': 'Month',

  'field.field': 'Field',
  'field.planned': 'planned',

  'field.growthStatus.growing': 'Growing',
  'field.growthStatus.harvestable': 'Ready to harvest',
  'field.growthStatus.cut': 'Cut',
  'field.growthStatus.unknown': 'Unknown',

  'crop.none': 'No crop',
  'crop.wheat': 'Wheat',
  'crop.barley': 'Barley',
  'crop.canola': 'Canola',
  'crop.oat': 'Oats',
  'crop.maize': 'Maize',
  'crop.sunflower': 'Sunflower',
  'crop.soybean': 'Soybean',
  'crop.potato': 'Potato',
  'crop.rice': 'Rice',
  'crop.rice_long_grain': 'Long-grain rice',
  'crop.sugar_beet': 'Sugar beet',
  'crop.sugar_cane': 'Sugar cane',
  'crop.cotton': 'Cotton',
  'crop.sorghum': 'Sorghum',
  'crop.grape': 'Grapes',
  'crop.olive': 'Olives',
  'crop.poplar': 'Poplar',
  'crop.beetroot': 'Red beet',
  'crop.carrot': 'Carrot',
  'crop.parsnip': 'Parsnip',
  'crop.green_bean': 'Green bean',
  'crop.pea': 'Pea',
  'crop.spinach': 'Spinach',
  'crop.grass': 'Grass',
  'crop.oilseed_radish': 'Oilseed radish',
  'crop.rye': 'Rye',
  'crop.millet': 'Millet',
  'crop.poppy': 'Poppy',
  'crop.spelt': 'Spelt',
  'crop.hops': 'Hops',
  'crop.lavender': 'Lavender',
  'crop.alfalfa': 'Alfalfa',
  'crop.clover': 'Clover',
  'crop.tobacco': 'Tobacco',
  'crop.hemp': 'Hemp',
  'crop.red_cabbage': 'Red cabbage',
  'crop.white_cabbage': 'White cabbage',
  'crop.meadow': 'Meadow',
  'crop.onion': 'Onion',

  'dashboard.noHarvestReady': 'No harvest ready',
  'dashboard.noHarvestReadyHint': 'No field is currently ready to harvest.',
  'dashboard.loadFieldsError': 'Could not load fields.',

  'task.harvest': 'Harvest',
  'task.plow': 'Plow',
  'task.lime': 'Lime',
  'task.cultivate': 'Cultivate',
  'task.sow': 'Sow',
  'task.fertilize': 'Fertilize',
  'task.mulch': 'Mulch',
  'task.roll': 'Roll',
  'task.weed': 'Remove weeds',
  'task.unknown': 'Task',
  'task.noOpenTasks': 'No open tasks',

  'task.status.open': 'Open',
  'task.status.planned': 'Planned',
  'task.status.done': 'Done',

  'task.form.title': 'New field planning',
  'task.form.field': 'Field',
  'task.form.selectField': 'Select field',
  'task.form.work': 'Work',
  'task.form.plannedFor': 'Planned for',
  'task.form.cancel': 'Cancel',
  'task.form.save': 'Save planning',

  'cropRotation.eyebrow': 'Crop planning',
  'cropRotation.title': 'Crop rotation',
  'cropRotation.subtitle':
    'Plan the crops for your fields across multiple growing periods.',
  'cropRotation.field': 'Field',
  'cropRotation.current': 'Current',
  'cropRotation.planned': 'Planned',
  'cropRotation.unfavorable': 'Unfavorable',
  'cropRotation.plan': 'Plan crop',
  'cropRotation.loading': 'Loading crop rotation...',
  'cropRotation.error': 'Could not load crop rotation.',

  'cropRotation.period.current': 'Current',
  'cropRotation.period.next': 'Next',
  'cropRotation.period.afterNext': 'After next',
  'cropRotation.period.later': 'Later +{count}',

  'cropRotation.advice.title': 'Crop rotation recommendation',
  'cropRotation.advice.loading': 'Loading recommendations...',
  'cropRotation.advice.error': 'Could not load recommendations.',
  'cropRotation.advice.saveError': 'Could not save crop planning.',
  'cropRotation.advice.recommended': 'Recommended',
  'cropRotation.advice.possible': 'Possible',
  'cropRotation.advice.warning': 'Warning',

  'cropRotation.advice.reason.cropBreak':
    'The recommended crop break for this crop has not yet been reached.',
  'cropRotation.advice.reason.repeatedCrop':
    'This crop was already grown in the previous period.',
  'cropRotation.advice.reason.cerealAfterCereal':
    'Cereal after cereal is possible, but not ideal for a diverse crop rotation.',
  'cropRotation.advice.reason.cropChange':
    'The change of crop is beneficial for the crop rotation.',
  'cropRotation.advice.reason.noHistory':
    'There is no previous growing period for this field yet.',

  'planning.tasks': 'Tasks',
  'planning.cropRotation': 'Crop rotation',

  'language.de': 'Deutsch',
  'language.en': 'English',
  'language.change': 'Change language',
} as const;

export type TranslationKey = keyof typeof en;
